var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Notifications Black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Notifications-Black",
    fill: "#505050",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0416667,45.3125 C28.1901042,45.3125 29.9479167,43.5096154 29.9479167,41.3060897 L22.1354167,41.3060897 C22.1354167,43.5096154 23.8736979,45.3125 26.0416667,45.3125 Z M37.7604167,33.2932692 L37.7604167,23.2772436 C37.7604167,17.1274038 34.5572917,11.9791667 28.9713542,10.6169872 L28.9713542,9.25480769 C28.9713542,7.59214744 27.6627604,6.25 26.0416667,6.25 C24.4205729,6.25 23.1119792,7.59214744 23.1119792,9.25480769 L23.1119792,10.6169872 C17.5065104,11.9791667 14.3229167,17.1073718 14.3229167,23.2772436 L14.3229167,33.2932692 L10.4166667,37.2996795 L10.4166667,39.3028846 L41.6666667,39.3028846 L41.6666667,37.2996795 L37.7604167,33.2932692 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationGrey);
export default __webpack_public_path__ + "static/media/notification-grey.2e212feb7d661001f6f5e0d6ec758fe1.svg";
export { ForwardRef as ReactComponent };